import { useQuery } from "@tanstack/react-query";
import { savedApi } from "../api/saved.api";
import { accountKeys } from "../constants/query-keys";

export function useMySaved(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: accountKeys.saved(),
    queryFn: savedApi.listMine,
    enabled: opts?.enabled,
  });
}
